var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeBulkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.39149 2.35151L2.61648 6.9765C1.96648 7.49317 1.54981 8.58484 1.69148 9.4015L2.79982 16.0348C2.99982 17.2182 4.13314 18.1765 5.33314 18.1765H14.6665C15.8582 18.1765 16.9998 17.2098 17.1998 16.0348L18.3081 9.4015C18.4415 8.58484 18.0248 7.49317 17.3831 6.9765L11.6081 2.35983C10.7165 1.64316 9.27482 1.64318 8.39149 2.35151Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 12.9167C11.1514 12.9167 12.0841 11.9839 12.0841 10.8333C12.0841 9.68274 11.1514 8.75 10.0008 8.75C8.85022 8.75 7.91748 9.68274 7.91748 10.8333C7.91748 11.9839 8.85022 12.9167 10.0008 12.9167Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBulkIcon);
export default __webpack_public_path__ + "static/media/home-bulk-icon.77f44c546807f5f7de8efd9e0457e1c7.svg";
export { ForwardRef as ReactComponent };